<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container v-if="userinfo.authAdmin == 2" fluid class="px-5">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">광고 등록</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">순서 변경 및 삭제는 아래 '광고 조회'에서 가능합니다.</span>

                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">분야를 선택해주세요.</span>
                                <v-btn :class="categoryIdx == 201 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 201">메인 배너</v-btn>
                                <v-btn :class="categoryIdx == 202 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 202">서브 베너</v-btn>
                                <v-btn :class="categoryIdx == 0 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 0">공모전</v-btn>
                                <v-btn :class="categoryIdx == 1 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 1">대외활동</v-btn>
                                <v-btn :class="categoryIdx == 2 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 2">동아리</v-btn>
                                <v-btn :class="categoryIdx == 4 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 4">인턴</v-btn>
                                <v-btn :class="categoryIdx == 7 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 7">교육/강연</v-btn>
                                <v-btn :class="categoryIdx == 8 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 8">장학금/지원</v-btn>
                                <v-btn :class="categoryIdx == 5 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 5">기타 포스터</v-btn>
                                <v-btn :class="categoryIdx == 200 ? 'mx-1 mt-1 bg-main-dark-opac-15 text-main': 'mx-1 mt-1 text-grey-2 border-grey-3'" outlined v-on:click="categoryIdx = 200">이벤트</v-btn>
    
                                <v-text-field dense label="광고 순서" outlined hint="순서를 입력해주세요(etc. 1, 2, 3..)" class="mt-5 col-8" v-model="orderNum" block></v-text-field>

                                <v-text-field v-if="(categoryIdx >= 0 && categoryIdx < 10) || categoryIdx == 200" dense label="포스터 번호 또는 이벤트 번호" outlined hint="번호를 입력해주세요." class="mt-1 col-8" v-model="contentIdx" block></v-text-field>
                                <v-row v-else>
                                    <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">광고 이미지를 업로드 해주세요.</span>
                                    <v-file-input dense accept="image/*" label="File input" class="mt-2 col-8" v-model="file" outlined></v-file-input>
                                    <v-btn v-if="!isUploaded" class="ml-2 mt-2 bg-main-dark text-white" v-on:click="upload()">이미지 업로드</v-btn>
                                    <v-btn v-else class="ml-2 mt-2 bg-main-dark-opac-15 text-main" outlined v-on:click="uploadInit()">이미지 초기화</v-btn>

                                    <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">광고 URL을 입력해주세요.</span>
                                    <v-text-field dense label="광고 URL 입력" outlined hint="URL을 입력해주세요." class="mt-5 col-8" v-model="adUrl" block></v-text-field>

                                    <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">광고 마감 날짜를 입력해주세요.</span>
                                    <v-col cols="8" class="px-1">
                                        <v-dialog
                                            ref="dateDialog"
                                            v-model="timeModal"
                                            :return-value.sync="openEndDate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="openEndDate"
                                                    label="공고마감시간"
                                                    prepend-icon="access_time"
                                                    readonly
                                                    v-on="on"
                                                >
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-if="timeModal"
                                                v-model="openEndDate"
                                                full-width
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.dateDialog.save(openEndDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                </v-row>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="ml-0 mr-auto">
                                    <v-btn class="bg-main-dark text-white border-main-rounded5 rem-1_2" block :height="60" outlined v-on:click="registerAdvert">광고 등록</v-btn>
                                </v-col>
                            </v-row>
    
                            <div style="height:100px;"></div>
    

                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">광고 조회</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">>메인 배너</span>
                                <span v-if="mainAdSeqChanging == false" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeMainAdSeq()">카테고리 순서변경</span>
                                <span v-if="mainAdSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="completeMainAdSeq()">순서 변경 완료</span>
                                <span v-if="mainAdSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeMainAdSeq()">취소</span>
                            </v-row>

                            <v-row v-if="mainAdList != null && mainAdList.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">업로드된 광고가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" v-for="(oneAd, index) in mainAdList">
                                    <v-card height="800" outlined elevation="5" class="">
                                        <v-img height="600" width="100%" :src="oneAd.photoUrl"></v-img>
                                        <!-- <v-card-title>{{}}</v-card-title> -->
                                        <v-card-subtitle class="text-left py-2">공개마감날짜: {{oneAd.openEndDate.substring(0, 10)}}</v-card-subtitle>
                                        <v-card-subtitle v-if="mainAdSeqChanging == false" class="text-left py-2">순서: {{oneAd.orderNum}}</v-card-subtitle>
                                        <v-text-field v-else dense label="광고 순서 변경" outlined hint="순서를 입력해주세요(etc. 1, 2, 3..)" class="py-2" v-model="oneAd.orderNum" :witdh="50"></v-text-field>

                                        <v-card-actions>
                                            <v-dialog v-model="mainAdDeleteDialog[index]" max-width="290">
                                                <template v-slot:activator="{ on }">
                                                    <v-row>
                                                        <v-btn class="bg-grey text-white  mx-auto" style="inline-block" :height="30" v-on="on">
                                                            <span>삭제</span>
                                                        </v-btn>
                                                    </v-row>
                                                </template>
                                                <v-card>
                                                        <v-card-title>주의</v-card-title>
                                                        <v-card-text>
                                                            <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                        </v-card-text>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="text-main" text @click="adminDelete(oneAd.adIdx)">예</v-btn>
                                                            <v-btn color="text-grey-1" text @click="mainAdDeleteDialog.splice(index, 1, false)">아니요</v-btn>
                                                        </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-row>
                                <span class="col-12 mt-5 text-left rem-1 text-grey-1">>서브 배너</span>
                                <span v-if="subAdSeqChanging == false" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeSubAdSeq()">카테고리 순서변경</span>
                                <span v-if="subAdSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="completeSubAdSeq()">순서 변경 완료</span>
                                <span v-if="subAdSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeSubAdSeq()">취소</span>
                            </v-row>

                            <v-row v-if="subAdList != null && subAdList.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">업로드된 광고가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" v-for="(oneAd, index) in subAdList">
                                    <v-card height="400" outlined elevation="5" class="">
                                        <v-img height="200" width="100%" :src="oneAd.photoUrl"></v-img>
                                        <!-- <v-card-title>{{}}</v-card-title> -->
                                        <v-card-subtitle class="text-left py-2">공개마감날짜: {{oneAd.openEndDate.substring(0, 10)}}</v-card-subtitle>
                                        <v-card-subtitle v-if="subAdSeqChanging == false" class="text-left py-2">순서: {{oneAd.orderNum}}</v-card-subtitle>
                                        <v-text-field v-else dense label="광고 순서 변경" outlined hint="순서를 입력해주세요(etc. 1, 2, 3..)" class="py-2" v-model="oneAd.orderNum" :witdh="50"></v-text-field>

                                        <v-card-actions>
                                            <v-dialog v-model="subAdDeleteDialog[index]" max-width="290">
                                                <template v-slot:activator="{ on }">
                                                    <v-row>
                                                        <v-btn class="bg-grey text-white  mx-auto" style="inline-block" :height="30" v-on="on">
                                                            <span>삭제</span>
                                                        </v-btn>
                                                    </v-row>
                                                </template>
                                                <v-card>
                                                        <v-card-title>주의</v-card-title>
                                                        <v-card-text>
                                                            <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                        </v-card-text>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="text-main" text @click="adminDelete(oneAd.adIdx)">예</v-btn>
                                                            <v-btn color="text-grey-1" text @click="subAdDeleteDialog.splice(index, 1, false)">아니요</v-btn>
                                                        </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-1 text-grey-1">>포스터</span>
                            </v-row>

                            <v-row v-if="posterList != null && posterList.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">업로드된 광고가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5" v-for="(oneAdRow, index1) in posterList">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">카테고리: {{oneAdRow[0].categoryName}}</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">카테고리 타이틀: {{oneAdRow[0].categoryDetail}}</span>
                                <span v-if="posterSeqChanging[index1] == false" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changePosterSeq(index1)">카테고리 순서변경</span>
                                <span v-if="posterSeqChanging[index1] == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="completePosterSeq(index1)">순서 변경 완료</span>
                                <span v-if="posterSeqChanging[index1] == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changePosterSeq(index1)">취소</span>
                                <span class="col-12"></span>
                                <v-col cols="12" md="4" v-for="(oneAd, index2) in oneAdRow">
                                    <v-card height="850" outlined elevation="5" class="">
                                        <v-img height="600" width="100%" :src="oneAd.photoUrl"></v-img>
                                        <v-card-subtitle class="text-left py-2">제목: {{oneAd.contentTitle}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-2">부제: {{oneAd.contentSubtitle}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-2">공개마감날짜: {{oneAd.openEndDate.substring(0, 10)}}</v-card-subtitle>
                                        <v-card-subtitle v-if="posterSeqChanging[index1] == false" class="text-left py-2">순서: {{oneAd.orderNum}}</v-card-subtitle>
                                        <v-text-field v-else dense label="광고 순서 변경" outlined hint="순서를 입력해주세요(etc. 1, 2, 3..)" class="py-2" v-model="oneAd.orderNum" :witdh="50"></v-text-field>

                                        <v-card-actions>
                                            <v-dialog v-model="posterDeleteDialog[index1][index2]" max-width="290">
                                                <template v-slot:activator="{ on }">
                                                    <v-row>
                                                        <v-btn class="bg-grey text-white  mx-auto" style="inline-block" :height="30" v-on="on">
                                                            <span>삭제</span>
                                                        </v-btn>
                                                    </v-row>
                                                </template>
                                                <v-card>
                                                        <v-card-title>주의</v-card-title>
                                                        <v-card-text>
                                                            <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                        </v-card-text>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="text-main" text @click="adminDelete(oneAd.adIdx)">예</v-btn>
                                                            <v-btn color="text-grey-1" text @click="posterDeleteDialog[index1].splice(index2, 1, false)">아니요</v-btn>
                                                        </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-row>
                                <span class="col-12 mt-5 text-left rem-1 text-grey-1">>이벤트</span>
                                <span v-if="eventSeqChanging == false" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeEventSeq()">카테고리 순서변경</span>
                                <span v-if="eventSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="completeEventSeq()">순서 변경 완료</span>
                                <span v-if="eventSeqChanging == true" class="pt-0 pl-3 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="changeEventSeq()">취소</span>
                            </v-row>

                            <v-row v-if="eventList != null && eventList.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">업로드된 광고가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" v-for="(oneAd, index) in eventList">
                                    <v-card height="500" outlined elevation="5" class="">
                                        <v-img height="200" width="100%" :src="oneAd.photoUrl"></v-img>
                                        <!-- <v-card-title>{{}}</v-card-title> -->
                                        <v-card-subtitle class="text-left py-2">제목: {{oneAd.contentTitle}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-2">부제: {{oneAd.contentSubtitle}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-2">공개마감날짜: {{oneAd.openEndDate.substring(0, 10)}}</v-card-subtitle>
                                        <v-card-subtitle v-if="eventSeqChanging == false" class="text-left py-2">순서: {{oneAd.orderNum}}</v-card-subtitle>
                                        <v-text-field v-else dense label="광고 순서 변경" outlined hint="순서를 입력해주세요(etc. 1, 2, 3..)" class="py-2" v-model="oneAd.orderNum" :witdh="50"></v-text-field>

                                        <v-card-actions>
                                            <v-dialog v-model="eventDeleteDialog[index]" max-width="290">
                                                <template v-slot:activator="{ on }">
                                                    <v-row>
                                                        <v-btn class="bg-grey text-white  mx-auto" style="inline-block" :height="30" v-on="on">
                                                            <span>삭제</span>
                                                        </v-btn>
                                                    </v-row>
                                                </template>
                                                <v-card>
                                                        <v-card-title>주의</v-card-title>
                                                        <v-card-text>
                                                            <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                        </v-card-text>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="text-main" text @click="adminDelete(oneAd.adIdx)">예</v-btn>
                                                            <v-btn color="text-grey-1" text @click="eventDeleteDialog[index1].splice(index, 1, false)">아니요</v-btn>
                                                        </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <div style="height:100px;"></div>

                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">카테고리 타이틀 및 순서 변경</span>
                                <span class="col-12 pt-0 text-left rem-1 text-main pointer-cursor" style="text-decoration: underline" @click="completeCategorySeq()">변경 완료</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">변경 완료 클릭 시, 바로 변경됩니다.</span>
                            </v-row>

                            <v-row class="mt-5">
                                <v-simple-table class="">
                                    <thead>
                                        <th>카테고리 이름</th>
                                        <th>카테고리 타이틀</th>
                                        <th>카테고리 순서</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="category in categoryList">
                                            <td class="text-left">{{category.categoryName}}</td>
                                            <td class="text-left">
                                                <v-text-field dense label="타이틀" outlined hint="타이틀을 입력해주세요." class="py-2" v-model="category.categoryDetail" :witdh="50"></v-text-field>
                                            </td>
                                            <td class="text-left">
                                                <v-text-field dense label="순서" outlined hint="순서를 입력해주세요." class="py-2" v-model="category.categoryOrder" :witdh="50"></v-text-field>
                                            </td>
                                            
                                        </tr>
                                    </tbody>
                                </v-simple-table>

                            </v-row>

                        </v-container>

                        

                        <!-- <v-container v-else-if="userinfo.authAdmin != 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">권한이 없습니다. 로그인 해주세요.</span>
                            </v-row>
                        </v-container> -->

                        <v-container v-else fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">로딩중...</span>
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.getAds()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,
            drawer: false,
            group: null,

            mainAdList: null,
            tmpMainAdList: null,
            subAdList: null,
            tmpSubAdList: null,
            posterList: null,
            tmpPosterList: null,
            eventList: null,
            tmpEventList: null,
            
            categoryList: null,

            categoryIdx: 201,
            orderNum: null,
            contentIdx: null,
            photoUrl: null,
            adUrl: null,

            timeModal: false,
            openEndDate: '',

            isUploaded: false,
        
            mainAdDeleteDialog: [],
            mainAdSeqChanging: false,

            subAdDeleteDialog: [],
            subAdSeqChanging: false,

            posterDeleteDialog: [],
            posterSeqChanging: [],

            eventDeleteDialog: [],
            eventSeqChanging: false,
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        registerAdvert() {
            if (this.orderNum == null || this.orderNum == '') {
                alert('광고 순서를 입력해주세요.')
                return
            }
            if (this.categoryIdx == 201 || this.categoryIdx == 202) {
                if(this.photoUrl == null || this.photoUrl == ''){
                    alert('광고 이미지를 등록해주세요.')
                    return
                }
                else if(this.openEndDate == null || this.openEndDate == ''){
                    alert('광고 마감 시간을 입력해주세요.')
                    return
                }
            } else{
                if(this.contentIdx == null || this.contentIdx == ''){
                    alert('포스터 번호 또는 이벤트 번호를 입력해주세요.')
                    return
                }
            }
            
            this.$http.post('/api/adverts', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                categoryIdx: this.categoryIdx,
                orderNum: this.orderNum,
                contentIdx: this.contentIdx,
                photoUrl: this.photoUrl,
                adUrl: this.adUrl,
                openEndDate: this.openEndDate,
            })
            .then(response => {
                if (response.data.status == 200) {
                    alert('광고 등록 완료')
                    window.location.reload()
                }
                else if(response.data.status == 400){
                    alert('잘못된 입력입니다.')
                }
                else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
        adminDelete(adIdx) {
            this.$http.delete(`/api/adverts/${adIdx}`)
                .then((response) => {
                    if (response.data.status == 200) {
                        window.location.reload()
                        alert('삭제 완료')
                        
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
        upload() {
            if (this.file == null) {
                alert('사진을 등록해주세요')
                return
            }
            var fd = new FormData()
            fd.append('imgFile', this.file, 'filename.jpg')

            this.$http.post(`/api/photos/reg`, fd)
                .then((response) => {
                    if (response.data.status == 200) {
                        console.log(response.data.data);
                        this.photoUrl = response.data.data.photoUrl.original
                        this.isUploaded = true
                        alert('업로드 완료!')
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                }).catch(error => {
                    console.log(error)
                })
        },
        uploadInit() {
            this.photoUrl = '',
            this.isUploaded = false
        },
        getAds() {
            this.$http.get('/api/adverts')
                .then((response) => {
                    console.log(response)
                    if (response.data.status == 200) {
                        this.eventList = response.data.data.eventList
                        this.mainAdList = response.data.data.mainAdList
                        this.subAdList = response.data.data.subAdList
                        this.posterList = response.data.data.posterList
                        this.categoryList = response.data.data.categoryList

                        this.mainAdDeleteDialog = []
                        for(var i = 0; i < this.mainAdList.length; i++){
                            this.mainAdDeleteDialog.push(false)
                        }
                        this.subAdDeleteDialog = []
                        for(var i = 0; i < this.subAdList.length; i++){
                            this.subAdDeleteDialog.push(false)
                        }
                        this.eventDeleteDialog = []
                        for(var i = 0; i < this.eventList.length; i++){
                            this.eventDeleteDialog.push(false)
                        }
                        this.posterDeleteDialog = []
                        this.posterSeqChanging = []
                        for(var i = 0; i < this.posterList.length; i++){
                            this.posterSeqChanging.push(false)
                            this.posterDeleteDialog.push([])
                            for(var j = 0; j < this.posterList[i].length; j++){
                                this.posterDeleteDialog[i].push(false)
                            }
                        }
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
        changePosterSeq(idx){
            var isChanging = this.posterSeqChanging[idx]
            if(isChanging == false){
                this.tmpPosterList = JSON.parse(JSON.stringify(this.posterList))
            }
            else{
                this.posterList = JSON.parse(JSON.stringify(this.tmpPosterList))
            }
            this.posterSeqChanging.splice(idx, 1, !isChanging)
        },
        completePosterSeq(idx){
            this.$http.post('/api/adverts/seq', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                posterList: this.posterList[idx]
            })
            .then(response => {
                if (response.data.status == 200) {
                    window.location.reload()
                    alert('순서 변경 완료')
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
        changeEventSeq(){
            var isChanging = this.eventSeqChanging
            if(isChanging == false){
                this.tmpEventList = JSON.parse(JSON.stringify(this.eventList))
            }
            else{
                this.eventList = JSON.parse(JSON.stringify(this.tmpEventList))
            }
            this.eventSeqChanging = !isChanging
        },
        completeEventSeq(){
            this.$http.post('/api/adverts/seq', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                posterList: this.eventList
            })
            .then(response => {
                if (response.data.status == 200) {
                    window.location.reload()
                    alert('순서 변경 완료')
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
        changeMainAdSeq(){
            var isChanging = this.mainAdSeqChanging
            if(isChanging == false){
                this.tmpMainAdList = JSON.parse(JSON.stringify(this.mainAdList))
            }
            else{
                this.mainAdList = JSON.parse(JSON.stringify(this.tmpMainAdList))
            }
            this.mainAdSeqChanging = !isChanging
        },
        completeMainAdSeq(){
            this.$http.post('/api/adverts/seq', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                posterList: this.mainAdList
            })
            .then(response => {
                if (response.data.status == 200) {
                    window.location.reload()
                    alert('순서 변경 완료')
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
        changeSubAdSeq(){
            var isChanging = this.subAdSeqChanging
            if(isChanging == false){
                this.tmpSubAdList = JSON.parse(JSON.stringify(this.subAdList))
            }
            else{
                this.subAdList = JSON.parse(JSON.stringify(this.tmpSubAdList))
            }
            this.subAdSeqChanging = !isChanging
        },
        completeMainAdSeq(){
            this.$http.post('/api/adverts/seq', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                posterList: this.subAdList
            })
            .then(response => {
                if (response.data.status == 200) {
                    window.location.reload()
                    alert('순서 변경 완료')
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
        completeCategorySeq(){
            this.$http.post('/api/adverts/category/seq', {
                headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                categoryList: this.categoryList
            })
            .then(response => {
                if (response.data.status == 200) {
                    window.location.reload()
                    alert('변경 완료')
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch(error => {
                console.log('server error', error)
            })
        },
    }
}
</script>

<style lang="css">

</style>


// WEBPACK FOOTER //
// src/pages/AllAdverts.vue